// extracted by mini-css-extract-plugin
module.exports = {"container":"Bio-module--container--1-_ux","imageContainer":"Bio-module--imageContainer--2oU_U","profilePic":"Bio-module--profilePic--1pvUA"};